import { render, staticRenderFns } from "./whs_home.vue?vue&type=template&id=eccda886&scoped=true&"
import script from "./whs_home.vue?vue&type=script&lang=js&"
export * from "./whs_home.vue?vue&type=script&lang=js&"
import style0 from "./whs_home.vue?vue&type=style&index=0&id=eccda886&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccda886",
  null
  
)

export default component.exports